<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} sản vật
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
              </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button @click="fn_handle('create')" type="info" plain>{{ aLang.c_create }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="thong_tin.ten" label="Tên">
          </el-table-column>
          <el-table-column prop="thong_tin.thanh_pho" label="Thành phố">
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete">
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import SanVatApi from '../../../moduleApi/SanVatApi';
import MethodService from '../../../service/MethodService';
import SanVatModel from './SanVatModel';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "SanVat", //requied
        tableRules: MethodService.copyObject(SanVatModel.tableRules),
        dataDefault: {}
      }
    }
  },
  created() {
    this.getSanVatList();
  },
  methods: {
    async getSanVatList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(() => { });
      }

      let res = await SanVatApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getSanVatList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getSanVatList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getSanVatList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getSanVatList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
    },

    async fn_delete(id) {
      await SanVatApi.delete(id);
      this.getSanVatList();
    }
  }
}
</script>
